import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';

interface HeaderProps {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  const navigate = useNavigate();

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    // Navegar al home y resetear filtros
    navigate('/', { 
      state: { 
        filter: 'todos',
        resetToTop: true 
      }
    });
    
    // Scroll al top inmediatamente
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <header id="header" className={`alt style2 ${className}`}> 
      <Link to="/" className="logo" onClick={handleLogoClick}>
        <img 
          src="https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/nombre%20web%20sin%20fondo.png" 
          alt="Gema Ruiz - Estilista" 
          className="logo-image"
        />
      </Link>
      <Navigation />
    </header>
  );
};

export default Header;
